<div *ngIf="formObject">
  <ng-container *ngIf="!invalidInput else invalidField">
    <mat-form-field appearance="standard" class="w-100 mt-n2">
      <mat-label
        [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">
        {{label ? label : isFromDate ? ('forms.common.input.date_from.label' | translate) : ('forms.common.input.date_to.label' | translate) }}
        <sup *ngIf="isInfo">
          <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
        </sup>
      </mat-label>
      <input matInput #inputElement [matDatepicker]="picker"
             [required]="required"
             [(ngModel)]="ngModelObject"
             [name]="elementName"
             [disabled]="isDisabled"
             placeholder="dd.mm.yyyy"
             (dateChange)="emitValue()"
             (ngModelChange)="updateValue($event)">
      <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
      <mat-datepicker #picker></mat-datepicker>
    </mat-form-field>
  </ng-container>
</div>

<ng-template #invalidField>
  <mat-form-field appearance="standard" class="w-100 mt-n2 mat-form-field-invalid ng-invalid">
    <mat-label
      [ngStyle]="isFirst ? {'visibility': 'visible'} : {'visibility' : 'hidden'}">
      {{isFromDate ? ('forms.common.input.date_from.label' | translate) : ('forms.common.input.date_to.label' | translate) }}
      <sup *ngIf="isInfo">
        <mat-icon class="fas fa-info" style="font-size: 0.5rem"></mat-icon>
      </sup>
    </mat-label>
    <input matInput #inputElement [matDatepicker]="picker"
           class="ng-invalid"
           [required]="required"
           [(ngModel)]="ngModelObject"
           [name]="elementName"
           placeholder="dd.mm.yyyy"
           (dateChange)="emitValue()"
           (ngModelChange)="updateValue($event)">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
    <mat-hint *ngIf="isFromDate" align="start" class="mt-1">{{'forms.common.error_message.dates_order' | translate}}</mat-hint>
  </mat-form-field>
</ng-template>
